<mat-form-field [appearance]="appearance" class="kategorie-auswahl-feld">

  <mat-label>{{ label }}</mat-label>

  <mat-select
    [value]="value"
    [disabled]="disabled"
    panelClass="kategorie-auswahl-panel"
    (selectionChange)="onAuswahl($event.value)"
    (openedChange)="onPanelGeoeffnet($event)"
    (keydown)="onTastatur($event)"
    (blur)="onTouched()">

    <!--
      Eigener Anzeigetext: ohne ihn stünde der komplette Optionstext – also
      auch die Beschreibung – im geschlossenen Feld.
    -->
    <mat-select-trigger *ngIf="gewaehlt">{{ gewaehlt.name }}</mat-select-trigger>

    <mat-option [value]="null" (mouseenter)="onLeerOptionHover()">
      {{ leerText }}
    </mat-option>

    <mat-option
      *ngFor="let k of kategorien; trackBy: trackById"
      [value]="k.id"
      class="kategorie-option"
      (mouseenter)="onOptionHover(k, $event)"
      (mouseleave)="onOptionVerlassen()">

      <span class="kategorie-option-text">
        <span class="kategorie-option-name">{{ k.name }}</span>
        <span class="kategorie-option-beschreibung" *ngIf="k.beschreibung">{{ k.beschreibung }}</span>
      </span>

      <!--
        Vorschau ohne Hover (Touch). Bewusst nicht per Tab erreichbar und für
        Vorleseprogramme unsichtbar: im offenen Dropdown bleibt der Fokus auf
        dem Feld, Tastaturnutzer bekommen die Vorschau über die Pfeiltasten.
      -->
      <span
        class="kategorie-option-info"
        role="presentation"
        aria-hidden="true"
        (mousedown)="onOptionInfoMousedown($event)"
        (click)="onOptionInfoKlick($event, k)">
        <mat-icon class="kategorie-option-info-icon">info_outline</mat-icon>
      </span>

    </mat-option>

  </mat-select>

  <button
    mat-icon-button
    matSuffix
    type="button"
    class="kategorie-auswahl-info"
    *ngIf="gewaehlt"
    [attr.aria-label]="'Prüfpunkte der Kategorie ' + gewaehlt.name + ' anzeigen'"
    [attr.aria-expanded]="vorschauQuelle === 'suffix'"
    [attr.aria-controls]="vorschauQuelle === 'suffix' ? vorschauId : null"
    matTooltip="Prüfpunkte dieser Kategorie anzeigen"
    (click)="onSuffixKlick($event)">
    <mat-icon>info_outline</mat-icon>
  </button>

  <mat-hint *ngIf="hint">{{ hint }}</mat-hint>

</mat-form-field>


<!--
  Die Vorschau liegt in einem eigenen Overlay – über dem Dropdown, nie darin.
  So bleibt die Optionsliste bedienbar, und die Vorschau kann neben ihr
  stehen statt sie zu verdecken.
-->
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="vorschauOrigin ?? hostElement"
  [cdkConnectedOverlayOpen]="vorschauOffen"
  [cdkConnectedOverlayPositions]="positionen"
  [cdkConnectedOverlayViewportMargin]="8"
  [cdkConnectedOverlayPush]="true"
  [cdkConnectedOverlayFlexibleDimensions]="false"
  [cdkConnectedOverlayHasBackdrop]="false"
  cdkConnectedOverlayPanelClass="kategorie-vorschau-pane"
  (overlayOutsideClick)="onAussenKlick($event)"
  (detach)="onVorschauAbgebaut()">

  <div
    class="kategorie-vorschau-popover"
    role="tooltip"
    [id]="vorschauId"
    (mouseenter)="onVorschauHover()"
    (mouseleave)="onVorschauVerlassen()">

    <app-kategorie-vorschau
      *ngIf="vorschauKategorie"
      [kategorie]="vorschauKategorie">
    </app-kategorie-vorschau>

  </div>

</ng-template>
